<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g :fill="color" :stroke="color" class="fill-current stroke-current">
      <path
        fill="#fff"
        d="M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
      />
      <path
        fill="#09104a"
        d="M26.28 10.608c-0.258-0.938-0.982-1.662-1.901-1.915l-0.019-0.005c-2.321-0.297-5.006-0.466-7.73-0.466-0.253 0-0.506 0.001-0.758 0.004l0.038-0c-0.23-0.003-0.503-0.005-0.775-0.005-2.707 0-5.376 0.167-7.995 0.492l0.313-0.032c-0.938 0.258-1.662 0.982-1.915 1.901l-0.005 0.019c-0.288 1.577-0.452 3.392-0.452 5.245s0.165 3.668 0.48 5.43l-0.028-0.186c0.258 0.932 0.983 1.649 1.901 1.892l0.019 0.004c2.306 0.293 4.975 0.461 7.682 0.461 0.273 0 0.545-0.002 0.817-0.005l-0.041 0c0.231 0.003 0.503 0.005 0.775 0.005 2.707 0 5.376-0.167 7.995-0.492l-0.313 0.032c0.937-0.247 1.662-0.964 1.916-1.877l0.004-0.019c0.288-1.577 0.452-3.392 0.452-5.245s-0.165-3.668-0.48-5.43l0.028 0.186zM13.694 19.072v-6.438l5.658 3.219z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
